import React from 'react';
import { Card, Skeleton } from './ui';

export const HeroSkeleton = () => (
  <div aria-hidden="true">
    <Skeleton className="h-3 w-24" />
    <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,19rem)_minmax(0,1fr)] lg:gap-x-10">
      <div>
        <Skeleton className="mt-3 h-9 w-44" />
        <Skeleton className="mt-3 h-5 w-48 rounded-full" />
        <div className="mt-5 grid grid-cols-2 gap-3">
          <Skeleton className="h-[60px] rounded-xl" />
          <Skeleton className="h-[60px] rounded-xl" />
        </div>
      </div>
      <Skeleton className="mt-5 h-40 w-full rounded-xl sm:h-52 lg:row-span-2 lg:mt-4" />
      <div className="mt-4 grid grid-cols-3 gap-4 border-t border-gray-100 pt-4 dark:border-gray-700/60">
        {[0, 1, 2].map((index) => (
          <div key={index}>
            <Skeleton className="h-3 w-14" />
            <Skeleton className="mt-2 h-4 w-16" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const RowsSkeleton = ({ rows = 4 }) => (
  <div className="space-y-3 py-1" aria-hidden="true">
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="flex items-center gap-3">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-3 flex-1" />
        <Skeleton className="h-3 w-16" />
      </div>
    ))}
  </div>
);

/** First paint before the user tree arrives; mirrors the real grid so nothing jumps. */
export default function DashboardSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-2 lg:grid-cols-12" aria-busy="true">
      <Card className="md:col-span-2 lg:col-span-12">
        <HeroSkeleton />
      </Card>
      <Card className="lg:col-span-7">
        <RowsSkeleton />
      </Card>
      <Card className="lg:col-span-5">
        <RowsSkeleton />
      </Card>
    </div>
  );
}
